export enum VehicleActionTypes {
  LOAD_VEHICLES_REQUEST = 'LOAD_VEHICLES_REQUEST',
  LOAD_VEHICLES_SUCCEEDED = 'LOAD_VEHICLES_SUCCEEDED',
  LOAD_VEHICLES_FAILED = 'LOAD_VEHICLES_FAILED',
  LOAD_VEHICLES_WITH_ODOMETER_REQUEST = 'LOAD_VEHICLES_WITH_ODOMETER_REQUEST',
  LOAD_VEHICLES_WITH_ODOMETER_SUCCEEDED = 'LOAD_VEHICLES_WITH_ODOMETER_SUCCEEDED',
  LOAD_VEHICLES_WITH_ODOMETER_FAILED = 'LOAD_VEHICLES_WITH_ODOMETER_FAILED',
  OPEN_ETA_PAGE_REQUEST = 'OPEN_ETA_PAGE_REQUEST',
  OPEN_ETA_PAGE_SUCCEEDED = 'OPEN_ETA_PAGE_SUCCEEDED',
  OPEN_ETA_PAGE_FAILED = 'OPEN_ETA_PAGE_FAILED',
  UPDATE_VEHICLE_TRACKING_REQUEST = 'UPDATE_VEHICLE_TRACKING_REQUEST',
  UPDATE_VEHICLE_TRACKING_SUCCEEDED = 'UPDATE_VEHICLE_TRACKING_SUCCEEDED',
  UPDATE_VEHICLE_TRACKING_FAILED = 'UPDATE_VEHICLE_TRACKING_FAILED',

  FILTER_VEHICLES_BY_STATUS = 'FILTER_VEHICLES_BY_STATUS',
  FILTER_VEHICLES_BY_DISABLER_STATUS = 'FILTER_VEHICLES_BY_DISABLER_STATUS',
}
